
module.exports = {"attributes":{"width":"28","height":"40"},"content":"<path d=\"M3.4 40h11L28 6V0H.6L0 12.3h1.1L3 7.5h23v.3z\"/>"}
var desvg = require('@kossnocorp/desvg/react')
module.exports = desvg(module.exports)
